import React from "react";
import Basic from "./chat";

function Footer({ customerPermission }) {

  return (
    <>
      <div className="container-fluid bottomFooter">
        <footer className="footer pt-3">
          <div className="row align-items-center justify-content-lg-between">
            <div className="col-lg-12 mb-lg-0 mb-4">
              <div className="copyright text-center text-sm text-muted text-lg-left">
                <h5 className='text-center tc'>Powered By Athena Fintech
                </h5>
              </div>
            </div>
            <div className="col-lg-6">
              <ul className="nav nav-footer justify-content-center justify-content-lg-end">
                <li className="nav-item">
                </li>
              </ul>
            </div>
            {customerPermission !== 'Customer' &&
              <div className="chatbot-container">
                < Basic />
              </div>
            }
          </div>
        </footer>
      </div>
    </>
  )
}

export default Footer
